import moment from 'moment';

// 백엔드에서 이미 마스킹된 전화번호에 하이픈만 추가 (마스킹 문자 * 보존)
// ex) 0107777**** → 010-7777-****
export const addPhoneHyphen = (phone?: string) => {
  if (!phone) return '';
  return phone.replace(/^([\d*]{3})([\d*]{3,4})([\d*]{4})$/, '$1-$2-$3');
};

// ISO 날짜 → YYYY-MM-DD (값 없으면 '-')
export const formatDate = (date?: string) => (date ? moment(date).format('YYYY-MM-DD') : '-');
